import React, { FC } from 'react';
import { Flex } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import type { TabNavigationProps } from '../../PhotoPickerDialog.types';
import { TabType } from '../../PhotoPickerDialog.types';
import { Chip } from '@apps/admin/components/Chip/Chip';

export const TabNavigation: FC<TabNavigationProps> = props => {
  const { selectedTab, onSelectTab, isCropTabDisabled, enableMobileCrop = false, isMobileCropTabDisabled = false } = props;
  const { tq } = useTranslation('photoPickerDialog');

  return (
    <Flex
      width="100%"
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
    >
      <Chip
        label={tq`Select`}
        isSelected={selectedTab === TabType.SELECT_PHOTO}
        onClick={() => onSelectTab(TabType.SELECT_PHOTO)}
      />
      <Chip
        label={enableMobileCrop ? tq`Desktop` : tq`Crop`}
        isSelected={selectedTab === TabType.CROP}
        onClick={() => onSelectTab(TabType.CROP)}
        isDisabled={isCropTabDisabled}
      />
      {enableMobileCrop && (
        <Chip
          label={tq`Mobile`}
          isSelected={selectedTab === TabType.MOBILE_CROP}
          onClick={() => onSelectTab(TabType.MOBILE_CROP)}
          isDisabled={isMobileCropTabDisabled}
        />
      )}
    </Flex>
  );
};
